import AutomaticLeads from "0.Mine/0.Components/Guides/AutomaticLeads";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

function AutoLeadsPage() {
  return (
    <DashboardLayout>
      <AutomaticLeads />
    </DashboardLayout>
  );
}

export default AutoLeadsPage;
